import { Button } from 'react-bootstrap';

const actions = ['stop', 'restart', 'start'];

const statusToCurrentAction = (status) => {
  switch (status) {
    case 'Running':
      return 'start';
    case 'Stopped':
      return 'stop';
    case 'Restarting':
      return 'restart';
    default:
      return null;
  }
};

export default function ActionButtons({ status = 'Unknown', onChange = () => {} }) {
  const currentAction = statusToCurrentAction(status);

  return (
    <div className="d-flex">
      {actions.map((action, index) => {
        const isCurrent = action === currentAction;
        const label = action.charAt(0).toUpperCase() + action.slice(1);

        return (
          <Button
            key={action}
            size="sm"
            variant={isCurrent ? 'primary' : 'dark'}
            className={`flex-fill fs-6 ${isCurrent ? 'text-white' : 'text-white-50'}`}
            style={{
              borderRadius: 0,
              border: '1px solid #56577A',
              borderLeftWidth: index === 0 ? '1px' : '0px',
              ...(index === 0 && {
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10,
              }),
              ...(index === actions.length - 1 && {
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10,
              }),
            }}
            onClick={(e) => {
              e.stopPropagation();
              onChange(action);
            }}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
}
